import {Component, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {SVGItems, svgNames} from '../svg/svgItems';
import {Select} from '@ngxs/store';
import {UsersSelectors} from '../../../core/store/users/users.selectors';
import {Observable} from 'rxjs';
import {EnvService} from '../../../models/env.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-modules-bar',
  templateUrl: './modules-bar.component.html',
  styleUrls: ['./modules-bar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModulesBarComponent {
  ICON_NAMES: SVGItems = svgNames;

  @Select(UsersSelectors.getPermissions) permissions$: Observable<any>;
  constructor(
    private router: Router,
    private envProvider: EnvService,
    public translate: TranslateService
  ) {}

  public showSection(sectionName: string): boolean {
    return !this.envProvider.environment.hiddenSections ||
      !this.envProvider.environment.hiddenSections.includes(sectionName.toLowerCase());
  }

  public isSelectedRoute(route: string) {
    return this.router.url.includes(route);
  }

  public navigate(route: string) {
    let currentRoute = this.router.url;
    if (!currentRoute.includes(route)) {
      this.router.navigate([route]);
    }
  }
}
